<template>
    <vx-card title="Edit User">
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span> Name</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" v-model="name" />
            </div>
        </div>

        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Country & Phone Number</span>
            </div>
            <div v-if="country" class="vx-col sm:w-2/3 w-full">
                <vue-tel-input mode='national' :valid-characters-only="true" :defaultCountry="countryIso" v-model="phone" :dynamicPlaceholder="false" name="country" type="number" v-on:country-changed="countryChanged" :disabledFetchingCountry="true" :enabledCountryCode="false"   class="vx-col w-full"	 ></vue-tel-input>
            </div>
        </div>

        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Country</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                 <vs-input disabled min="0" class="w-full" type="text" v-model="country" />
            </div>
        </div>

        
        






        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Email</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                 <vs-input min="0" class="w-full" type="email" v-model="email" />
            </div>
        </div>
        




        

        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Status</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-switch v-model="status" />   
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
                <vs-button @click="editUser" class="mr-3 mb-2">Save</vs-button>
                <vs-button color="warning" type="border" class="mb-2"
                    @click="() => $router.push(`/users-list`).catch(() => {})">Cancel</vs-button>
            </div>
        </div>
    </vx-card>
</template>

<script>
    import vSelect from 'vue-select'

    export default {
        components: {
            'v-select': vSelect
        },
        created() {
            
            this.getUserById()
           
        },
        data() {
            return {
                name: '',
                phone: '',
                email: 'qwe',
                status: '',
                country: '',
                countryCode: '',
                countryIso: '',
            }
        },
        methods: {
            countryChanged(country) {
        this.countryCode = country.dialCode
        this.country = country.name
        this.countryIso = country.iso2
      },
            getUserById() {
                this.$store.dispatch('user/getUserById', this.$route.params.userId)
                    .then((response) => {
                        console.log('RES:', response.data.data.country)
                        this.name = response.data.data.name
                        this.email = response.data.data.email
                        this.phone = response.data.data.phone
                        this.country = response.data.data.country
                        this.countryCode = response.data.data.countryCode
                        this.countryIso = response.data.data.countryIso
                        this.status = response.data.data.isActive
                    })
                    .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    })
            },
            editUser(){
                this.$vs.loading()
                const payload = {}
                
                payload["Id"] = this.$route.params.userId
                payload["Name"] = this.name
                payload["Email"] = this.email
                payload["Country"] = this.country
                payload["CountryCode"] = this.countryCode
                payload["CountryIso"] = this.countryIso
                payload["Phone"] = this.phone
                payload["IsActive"] = this.status
                this.$store.dispatch('user/updateUserById',payload)
                .then(response => {
                     this.$vs.loading.close()
                        this.$vs.notify({
                            title: 'Successfull',
                            text: response.data.message,
                            iconPack: 'feather',
                            icon: 'icon-check-circle',
                            color: 'success'
                        })
                        setTimeout(()=> this.$router.push('/users-list'), 500)
                })
                .catch(error =>{
                    this.$vs.loading.close()
                        this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                })
            },

          
        }
    }
</script>

<style>

</style>